/* eslint-disable no-console */
/* eslint-disable no-undef */
export const ddoInit = (ddo) => {
  if (window._T && typeof (_T.sendPageDataToAnalytics) !== 'undefined') {
    _T.sendPageDataToAnalytics(ddo);
  } else {
    window._T = (window._T ? _T : {});
    _T.pageData = (window._T.pageData ? _T.pageData : []);
    _T.pageData.push(ddo || window.digitalData);
  }
};

export const ddoEventInit = (eventObj, IsConsoleDebug = window.settings.isConsoleDebug) => {
  if (window._T && typeof (_T.sendEventDataToAnalytics) !== 'undefined') {
    _T.sendEventDataToAnalytics(eventObj);

    if (IsConsoleDebug) {
      console.log('Sent Omniture Event: ' + JSON.stringify(eventObj));
    }
  } else {
    window._T = (window._T ? _T : {});
    _T.eventData = (window._T.eventData ? _T.eventData : []);
    _T.eventData.push(eventObj);
    if (console && console.log) {
      console.log('window._T undefined. Attempting to publish:' + JSON.stringify(eventObj));
    }
  }
};
